<template>
  <div class="waypoint-list-panel">
    <!-- <el-table :data="waypoints" size="mini">
      <el-table-column type="selection" align="center" width="50px">
      </el-table-column>
      <el-table-column align="center" type="index" :label="$t('route.waypoint.waypoint')">
        <template slot-scope="scope"> {{ scope.$index + 1
        }}</template>
</el-table-column>
<el-table-column align="center" prop="altitude" :label="$t('route.waypoint.altitude')">
  <template slot-scope="scope">
          <el-popover :ref="'altitudetips' + scope.$index + 1" placement="top" width="200"
            popper-class="el-popper--mixmapstyle" :value="altVisible === scope.$index ? true : false" trigger="manual">
            <div class="alt-main">
              <div class="alt-title">
                {{ $t('route.waypoint.setRouteAltitude') }}
                <el-tooltip class="alt-tips" effect="light" placement="bottom">
                  <div slot="content">
                    <p style="padding-bottom: 10px">
                      {{ $t('route.waypoint.batchModifyAltitude') }}
                    </p>
                    <p>{{ $t('route.waypoint.notModifyAltitude') }}</p>
                  </div>
                  <i class="el-icon-question" style="display: inline-block; margin-left: 10px"></i>
                </el-tooltip>
              </div>
              <div class="alt-display">
                <el-input class="alt-input" type="number" :placeholder="$t('route.waypoint.enterAltitude')" :max="1100"
                  :min="0" v-model="altitudeVal" />
                <div class="alt-bottom">
                  <el-button class="alt-btn1 btn-close" @click="altVisible = -1">{{ $t('route.waypoint.cancel')
                    }}</el-button>
                  <el-button type="primary" class="alt-btn2 btn-define" @click="binAlt(scope.$index)">{{
                    $t('route.waypoint.confirm') }}</el-button>
                </div>
              </div>
            </div>
            <div slot="reference" @dblclick.stop="
              !showEdit && binVisible(scope.$index, 'altitude')
              ">
              {{ scope.row.altitude }}
            </div>
          </el-popover>
        </template>
</el-table-column>
<el-table-column align="center" prop="speed" :label="$t('route.waypoint.speed')">
  <template slot-scope="scope">
          <el-popover :ref="'speedtips' + scope.$index + 1" placement="top" width="200"
            popper-class="el-popper--mixmapstyle" :value="speedVisible === scope.$index ? true : false"
            trigger="manual">
            <div class="alt-main">
              <div class="alt-title">
                {{ $t('route.waypoint.setRouteSpeed') }}
                <el-tooltip class="alt-tips" effect="light" placement="bottom">
                  <div slot="content">
                    <p style="padding-bottom: 10px">
                      {{ $t('route.waypoint.batchModifySpeed') }}
                    </p>
                    <p>{{ $t('route.waypoint.notModifySpeed') }}</p>
                  </div>
                  <i class="el-icon-question" style="display: inline-block; margin-left: 10px"></i>
                </el-tooltip>
              </div>
              <div class="alt-display">
                <el-input class="alt-input" type="number" :placeholder="$t('route.waypoint.enterSpeed')" :max="30"
                  :min="0" v-model="speedVal" />
                <div class="alt-bottom">
                  <el-button class="alt-btn1 btn-close" @click="speedVisible = -1">{{ $t('route.waypoint.cancel')
                  }}</el-button>
                  <el-button type="primary" class="alt-btn2 btn-define" @click="binSpeed(scope.$index)">{{
                    $t('route.waypoint.confirm') }}</el-button>
                </div>
              </div>
            </div>
            <div slot="reference" @dblclick.stop="
              !showEdit && binVisible(scope.$index, 'speed')
              ">
              {{ scope.row.speed }}
            </div>
          </el-popover>
        </template>
</el-table-column>
<el-table-column align="center" :label="$t('route.waypoint.poi')">
  <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :popper-class="scope.row.actions && scope.row.actions.length > 5
            ? 'actions-tooltip actions_mask-600'
            : 'actions-tooltip actions_mask'
            ">
            <template v-slot:content>
              <template v-if="scope.row.actions && scope.row.actions.length > 0">
                <div class="actions-desc" :class="index !== 0 ? 'mar-top-16' : ''"
                  v-for="(item, index) in scope.row.actions" :key="index">
                  <div class="actions-label">{{ $t('route.waypoint.action') }}{{
                    index + 1 }}</div>
                  <div class="actions-value">
                    {{ getActions(item.type) }}
                  </div>
                </div>
              </template>
  <template v-else>
                <div>{{ $t('route.waypoint.noAction') }}</div>
              </template>
  </template>
  <div class="actions-txt">
    {{
    scope.row.actions && scope.row.actions.length > 0
    ? scope.row.actions.length
    : 0
    }}
  </div>
  </el-tooltip>

  </template>
</el-table-column>
<el-table-column align="center" :label="$t('route.waypoint.operation')">
  <template slot-scope="scope">

          <i style="cursor: pointer; font-size: 12px" @click.stop="handleDeleteClick(scope.row, scope.$index)"
            class="el-icon-delete icon-delete"></i>
        </template>
</el-table-column>
</el-table> -->
    <div v-for="(item, index) in waypoints" :key="index" class="waypoint-list-item"
      :class="{ 'waypoint-list-item--active': index === currentIndex }" @click="handleListItemClick(item, index)">

      <div class="waypoint-index">{{ index + 1 }}</div>
      <div class="waypoint-content">
        <el-row :gutter="10" style="margin-bottom:8px">
          <el-col :span="12">
            <div>
              <span class="waypoint-label">{{ $t('route.waypoint.altitude') }}</span>
              <span>
                {{ item.altitude }}
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <span class="waypoint-label">{{ $t('route.waypoint.speed') }}</span>
              <span>
                {{ item.speed }}
              </span>
            </div>
          </el-col>
        </el-row>


        <div class="waypoint-container">
          <span class="waypoint-label">{{ $t('route.waypoint.poi') }}</span>
          <span class="waypoint-container__content">
            <template v-if="item.actions && item.actions.length > 0">
              <div class="waypoint-action" v-for="(actionItem, index2) in item.actions" :key="index2">
                <!-- <div class="actions-label">{{ $t('route.waypoint.action') }}{{
                  index2 + 1 }}</div> -->
                <div class="actions-value">
                  {{ getActions(actionItem.type) }}
                </div>
              </div>
            </template>
            <template v-else>
              <div style="font-size: 12px;color:rgba(255,255,255,0.5)">{{ $t('route.waypoint.noAction') }}</div>
            </template>
          </span>
        </div>

      </div>
      <div class="waypoint-operation" v-if="editable && showDelete">
        <i style="cursor: pointer; font-size: 16px" @click.stop="handleDeleteClick(item, index)"
          class="el-icon-delete icon-delete"></i>
      </div>
    </div>
    <div v-if="settingVisible" class="waypoint-setting">
      <PointSetting :index.sync="currentIndex" :point="currentPoint" :poiLength="waypoints.length"
        @close="settingVisible = false" @currentChange="handleSettingCurrentChange"
        @useGlobalSpeedChange="handleUseGlobalSpeedChange" :SeeShow="!editable || isGridWay"></PointSetting>
    </div>
  </div>

</template>

<script>
import PointSetting from '../../../main/PointSetting.vue';
export default {
  name: "WaypointListPanel",
  components: {
    PointSetting
  },
  props: {
    waypoints: {
      type: Array,
      default: () => [
        // {}
      ]
    },
    waylineConfig: {
      type: Object,
      default: () => ({})
    },
    editable: {//是否可编辑
      type: Boolean,
      default: false
    },
    /**
     * 是否显示删除图标或者按钮，默认不显示
     */
    showDelete: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      settingVisible: false,
      currentIndex: 0,
      currentPoint: {}

    };
  },
  computed: {
    /**
 * 判断是否为网格航线
 *
 * @returns {boolean} 如果为网格方式，返回 true；否则返回 false
 */
    isGridWay() {
      let flag = false
      if (this.waylineConfig) {
        flag = !!this.waylineConfig.isGridWay
      }
      return flag
    },
  },
  methods: {
    handleListItemClick(item, index) {
      this.currentIndex = index;
      this.currentPoint = item;
      this.settingVisible = true;
    },
    handleDeleteClick(row, index) {
      // this.$emit('deleteWaypoint', row, index);
      let waypointList = JSON.parse(JSON.stringify(this.waypoints))
      waypointList.splice(index, 1)
      this.emitWaypointListChange(waypointList)
    },

    getActions(type) {


      switch (type) {
        case 'STAY':
          return this.$t('route.waypoint.hover');
        case 'START_TAKE_PHOTO':
          return this.$t('route.waypoint.takePhoto');
        case 'START_RECORD':
          return this.$t('route.waypoint.startRecord');
        case 'STOP_RECORD':
          return this.$t('route.waypoint.endRecord');
        case 'ROTATE_AIRCRAFT':
          return this.$t('route.waypoint.adjustHeading');
        case 'GIMBAL_PITCH':
          return this.$t('route.point.adjustGimbalVertical');
        case 'GIMBAL_YAW':
          return '调整云台方向(左右)';
        case 'ZOOM':
          return '调整变焦';
        case 'PANO_SHOT':
          return '全景拍照';
        default:
          return '';
      }
    },
    handleSettingCurrentChange(index) {
      this.currentIndex = index;
      let point = this.waypoints[index];
      console.log(point);
      this.currentPoint = point;
    },
    handleUseGlobalSpeedChange(useGlobalSpeed, data) {

      if (useGlobalSpeed) {
        if (this.waylineConfig) {
          const index = data.index
          let globalSpeed = this.waylineConfig.speed || 1
          if (globalSpeed <= 1) {
            globalSpeed = 1
          }
          let points = this.waypoints || []
          let point = points[index]
          if (point) {
            point.speed = globalSpeed

          }

        }
      }

    },
    emitWaypointListChange(waypoints) {
      console.log(waypoints, 'waypoints')
      this.$emit('waypointListChange', waypoints)
    }
  },
  mounted() { },
};
</script>


<style lang="scss" scoped>
.waypoint-list-panel {
  ::v-deep .el-table {
    background-color: #082e51 !important;

    &::before {
      height: 0px !important;
    }

    th.el-table__cell,
    tr {
      background-color: #071150 !important;
      color: #fff;
    }

    th.el-table__cell,
    td.el-table__cell {
      border: 0px !important;
    }

    .el-table__body tr.current-row>td.el-table__cell {
      background: rgba(0, 65, 163, 0.21) !important;
      color: #49f0fd;
      cursor: pointer;
    }

    tr:hover>td {
      background: rgba(0, 65, 163, 0.21) !important;
    }
  }

  .waypoint-list-item {

    position: relative;
    min-height: 20px;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    background-color: #071150 !important;
    border-bottom: 1px solid #0041a3;

    &:first-child {
      border-top: 1px solid #0041a3;
    }

    &:hover,
    &--active {
      background-color: rgba(0, 65, 163, 0.21) !important;
    }



    .waypoint-index {
      width: 32px;
      text-align: center;
      background-color: #112d7b;
      // 确保高度至少和父元素一致
      min-height: inherit;
      // 覆盖父元素的 align-items 样式
      align-self: stretch;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      font-size: 12px;

    }

    .waypoint-content {
      flex: 1;
      padding: 10px 6px;
    }

    .waypoint-label {
      position: relative;
      color: rgba(255, 255, 255, 0.7);
      flex-shrink: 0;

      &::after {
        content: ":";
        margin-left: 4px;
        margin-right: 4px;
      }
    }

    .waypoint-operation {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 30px;
      max-width: 80px;
      text-align: center;
      flex-shrink: 0;
      // 覆盖父元素的 align-items 样式
      align-self: stretch;
    }

    .icon-delete {
      // cursor: pointer;
      margin-left: 2px;
      color: #ff265b;
      font-size: 16px;
    }

    .waypoint-container {
      display: flex;
      box-sizing: border-box;

      &__content {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
      }

      .waypoint-action {
        color: #49f0fd;
        border: 1px solid #2e7df8;
        margin: 2px;
        padding: 4px;
        font-size: 12px;
        border-radius: 2px;
      }
    }

  }
}

.waypoint-setting {
  position: fixed;
  right: 420px;
  top: 140px;
  width: 320px;
  height: calc(100% - 168px);
  border: 1px solid #04203b;
  z-index: 10000;
  background-color: #071150;
}
</style>